module.exports = __webpack_public_path__ + "img/tooltip_litho-board-4.6d8b488a.jpg";